module.exports = __webpack_public_path__ + "img/E_SDG_Icons-12.6bd2ec4f.jpg";